import CouponMarketplaceTabs from './coupon-marketplace-tabs-view'

export default CouponMarketplaceTabs
